module.exports = __webpack_public_path__ + "img/honor4.ad58803a.png";